module.exports = __webpack_public_path__ + "img/2857.c9a8bb07.png";